import styles from "./PopupSection.module.scss";

interface IPopupSectionProps {
    title: string;
    children?: JSX.Element;
    className?: string;
}

function PopupSection(props: IPopupSectionProps): JSX.Element {
    return (
        <div className={props.className ?? styles.section}>
            <span>{props.title}</span>
            <hr />
            {props.children}
        </div>
    );
}

export { PopupSection };
